export default __webpack_public_path__ + "static/media/Arrow.e9dec063.svg";